import React from 'react';

import Typography from 'components/Typography';
import { NumberRangeFormatter } from 'intl';

import { IDescriptionRangeDecimal } from './interfaces';

export const DescriptionRangeDecimal: React.FC<IDescriptionRangeDecimal> = ({
  value,
  maximumFractionDigits = 2,
  ...other
}) => {
  return (
    <Typography {...other}>
      <NumberRangeFormatter.Decimal
        value={value}
        maximumFractionDigits={maximumFractionDigits}
      />
    </Typography>
  );
};
